import React from 'react';
import { FileText, Download, Send } from 'lucide-react';
import { useApp } from './AppContext';
import { useTranslation } from '../i18n/TranslationContext';

export function ContractSignAndSend() {
  const { markContractAsSent, downloadContract } = useApp();
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-2xl p-6 shadow-[0_4px_16px_rgba(0,0,0,0.08)] mb-6">
      <div className="flex items-center mb-4">
        <div className="w-8 h-8 bg-[var(--ucm-light-orange)] rounded-full flex items-center justify-center mr-3">
          <FileText size={16} className="text-[var(--ucm-dark-orange)]" />
        </div>
        <h3 className="font-semibold text-[var(--ucm-text-dark)]">{t('contract.process.title')}</h3>
      </div>

      <div className="mb-4">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-[var(--ucm-text-medium)]">{t('contract.status.label')}:</span>
          <span className="text-sm font-semibold text-[var(--ucm-warning-orange)]">{t('contract.status.signAndSendRequired')}</span>
        </div>
        <p className="text-sm text-[var(--ucm-text-medium)] mb-3">
          {t('contract.signAndSend.description')}
        </p>
        
        <div className="bg-[var(--ucm-light-blue)] rounded-xl p-3 mb-4">
          <p className="text-xs font-medium text-[var(--ucm-dark-blue)] mb-2">{t('contract.signAndSend.instructions.title')}:</p>
          <ul className="text-xs text-[var(--ucm-dark-blue)] space-y-1">
            <li>{t('contract.signAndSend.instructions.step1')}</li>
            <li>{t('contract.signAndSend.instructions.step2')}</li>
            <li>{t('contract.signAndSend.instructions.step3')}</li>
          </ul>
        </div>
        
        <div className="text-xs text-[var(--ucm-text-light)] mb-4">
          {t('contract.progress.step', { current: 5, total: 8 })}
        </div>
      </div>

      <div className="space-y-3">
        <button
          onClick={markContractAsSent}
          className="w-full h-12 bg-[var(--ucm-primary-teal)] text-white font-semibold rounded-full hover:bg-[var(--ucm-primary-teal-hover)] transition-colors duration-200 flex items-center justify-center"
        >
          <Send size={16} className="mr-2" />
          {t('contract.signAndSend.markAsSent')}
        </button>
        
        <button
          onClick={downloadContract}
          className="w-full h-12 bg-white border border-[var(--ucm-border-light)] text-[var(--ucm-text-dark)] font-semibold rounded-full hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center"
        >
          <Download size={16} className="mr-2" />
          {t('contract.signAndSend.downloadAgain')}
        </button>
      </div>
    </div>
  );
}